"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PauseAuctionResponseDtoAuctionStatusEnum = void 0;
exports.instanceOfPauseAuctionResponseDto = instanceOfPauseAuctionResponseDto;
exports.PauseAuctionResponseDtoFromJSON = PauseAuctionResponseDtoFromJSON;
exports.PauseAuctionResponseDtoFromJSONTyped = PauseAuctionResponseDtoFromJSONTyped;
exports.PauseAuctionResponseDtoToJSON = PauseAuctionResponseDtoToJSON;
exports.PauseAuctionResponseDtoToJSONTyped = PauseAuctionResponseDtoToJSONTyped;
/**
 * @export
 */
exports.PauseAuctionResponseDtoAuctionStatusEnum = {
    ToBeStarted: 'to_be_started',
    InProgress: 'in_progress',
    Paused: 'paused',
    Completed: 'completed',
    Cancelled: 'cancelled'
};
/**
 * Check if a given object implements the PauseAuctionResponseDto interface.
 */
function instanceOfPauseAuctionResponseDto(value) {
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('pausedAt' in value) || value['pausedAt'] === undefined)
        return false;
    if (!('auctionStatus' in value) || value['auctionStatus'] === undefined)
        return false;
    return true;
}
function PauseAuctionResponseDtoFromJSON(json) {
    return PauseAuctionResponseDtoFromJSONTyped(json, false);
}
function PauseAuctionResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'listingId': json['listingId'],
        'pausedAt': (new Date(json['pausedAt'])),
        'auctionStatus': json['auctionStatus'],
    };
}
function PauseAuctionResponseDtoToJSON(json) {
    return PauseAuctionResponseDtoToJSONTyped(json, false);
}
function PauseAuctionResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'listingId': value['listingId'],
        'pausedAt': value['pausedAt'].toISOString(),
        'auctionStatus': value['auctionStatus'],
    };
}
